<template>
  <div class="page-content d-flex align-items-center justify-content-center">
    <div class="row w-100 mx-0 auth-page">
      <div class="col-md-8 col-xl-10 mx-auto">
        <div class="card">
          <div class="auth-form-wrapper px-4 py-5">
            <h4 class="mb-4">Create a free account.</h4>
            <Alert />
            <form class="forms-sample" @submit.prevent="regist">
              <div class="row">
                <div class="col-xl-6 col-md-12">
                  <div class="form-group">
                    <label for="input-company-name">Company Name</label>
                    <input type="text" class="form-control" id="input-company-name" placeholder="Company Name" name="company-name" v-model="v$.form.company_name.$model">
                    <span class="text-danger" v-if="v$.form.company_name.$errors[0]">
                      {{ v$.form.company_name.$errors[0].$message }}
                    </span>
                  </div>
                  <div class="form-group">
                    <label for="input-company-brand">Company Brand</label>
                    <input type="text" class="form-control" id="input-company-brand" placeholder="Company Brand" name="company-brand" v-model="v$.form.company_brand.$model">
                    <span class="text-danger" v-if="v$.form.company_brand.$errors[0]">
                      {{ v$.form.company_brand.$errors[0].$message }}
                    </span>
                  </div>
                </div>
                <div class="col-xl-6 col-md-12">
                  <div class="form-group">
                    <label for="input-company-address">Company Address</label>
                    <textarea class="form-control" id="input-company-address" rows="7" placeholder="Company Address" v-model="v$.form.company_address.$model"></textarea>
                    <span class="text-danger" v-if="v$.form.company_address.$errors[0]">
                      {{ v$.form.company_address.$errors[0].$message }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-6 col-md-12">
                  <div class="form-group">
                    <label for="input-name">Name</label>
                    <input type="text" class="form-control" id="input-name" placeholder="Name" name="name" v-model="v$.form.name.$model">
                    <span class="text-danger" v-if="v$.form.name.$errors[0]">
                      {{ v$.form.name.$errors[0].$message }}
                    </span>
                  </div>
                </div>
                <div class="col-xl-6 col-md-12">
                  <div class="form-group">
                    <label for="input-phone-number">Phone Number</label>
                    <input type="tel" class="form-control" id="input-phone-number" placeholder="62xxx" name="phone_number" v-model="v$.form.phone_number.$model">
                    <span class="text-danger" v-if="v$.form.phone_number.$errors[0]">
                      {{ v$.form.phone_number.$errors[0].$message }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-6 col-md-12">
                  <div class="form-group">
                    <label for="input-email">Email address</label>
                    <input type="email" class="form-control" id="input-email" placeholder="Email" v-model="v$.form.email.$model">
                    <span class="text-danger" v-if="v$.form.email.$errors[0]">
                      {{ v$.form.email.$errors[0].$message }}
                    </span>
                  </div>
                </div>
                <div class="col-xl-6 col-md-12">
                  <div class="form-group">
                    <label for="input-password">Password</label>
                    <input type="password" class="form-control" id="input-password" placeholder="Password" v-model="v$.form.password.$model">
                    <span class="text-danger" v-if="v$.form.password.$errors[0]">
                      {{ v$.form.password.$errors[0].$message }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="mt-3">
                <el-checkbox v-model="v$.form.accept_terms_condition.$model">I accept <a target="_blank" href="https://wappin.id/policy">terms and condition</a></el-checkbox>
                <br/>
                <button :disabled="v$.form.$error" type="submit" class="btn btn-primary text-white mr-2 mb-2 mb-md-0">Sign up</button>
              </div>
              <a href="/auth/login" class="d-block mt-3 text-muted">Already a user? Sign in</a>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import useVuelidate from '@vuelidate/core';
import {
  required, helpers, minLength,
} from '@vuelidate/validators';

import authAPI from '../../../api/auth';
import passwordComplexity from '../../../library/password-complexity';

Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA_SITEKEY });

export default {
  name: 'Register',
  metaInfo: {
    title: 'Register',
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    return {
      form: {
        password: {
          required,
          minLength: minLength(8),
          complexity: helpers.withMessage(() => 'Password should have at least 1 uppercase, 1 lowercase, 1 number and 1 special character', passwordComplexity),
        },
        company_name: { required },
        company_brand: { required },
        company_address: { required },
        name: { required },
        phone_number: { required },
        email: { required },
        accept_terms_condition: { required, checked: (value) => value === true },
      },
    };
  },
  data() {
    return {
      form: {
        company_name: '',
        company_brand: '',
        company_address: '',
        name: '',
        phone_number: '',
        email: '',
        password: '',
        captcha_token: '',
        accept_terms_condition: false,
        app_source: '',
      },
    };
  },
  mounted() {
    this.v$.form.$touch();
  },
  methods: {
    async regist() {
      this.v$.form.$touch();
      if (this.v$.form.$error) return;

      await this.$recaptchaLoaded();
      this.form.captcha_token = await this.$recaptcha();

      const loader = this.$loading.show();
      if (process.env.VUE_APP_COBRAND) {
        this.form.app_source = process.env.VUE_APP_COBRAND;
      }
      await authAPI.register(this.form)
        .then(async (res) => {
          if (!res.error) {
            await this.$store.dispatch('ui/alertSuccess', 'Register success! Please check your email for verification');
            this.$router.push('/auth/login');
          } else {
            await this.$store.dispatch('ui/alertError', res.error.message);
            this.showAlert();
          }
        })
        .catch(async () => {
          await this.$store.dispatch('ui/alertError', 'Something went wrong');
          this.showAlert();
        });
      loader.hide();
    },
  },
  beforeMount() {
    this.$recaptchaInstance.showBadge();
  },
  beforeDestroy() {
    this.$recaptchaInstance.hideBadge();
  },
};
</script>
